import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { ICookieConsentPopupResult } from '@app/shared/services/cookie-consent-popup/cookie-consent-popup-result';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-cookie-consent-popup',
  templateUrl: './cookie-consent-popup.component.html',
  styleUrls: ['./cookie-consent-popup.component.scss']
})
export class CookieConsentPopupComponent {

  subject: Subject<ICookieConsentPopupResult>;
  settingsMode = false;
  analyticsEnabled = false;

  readonly switchColor = '#1bb1a4';

  constructor(private bsModalRef: BsModalRef) { }

  toggleSettingsMode(): void {
    this.settingsMode = !this.settingsMode;
  }

  onCloseClicked() {
    this.subject.next({ googleAnalyticsEnabled: this.settingsMode ? this.analyticsEnabled : true });
    setTimeout(() => {
      this.subject.complete();
    }, 0);
    this.bsModalRef.hide();
  }

}
